// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EventRead } from "./EventRead";
import {
  EventReadFromJSON,
  EventReadFromJSONTyped,
  EventReadToJSON,
  EventReadToJSONTyped,
} from "./EventRead";

/**
 *
 * @export
 * @interface PageEventRead
 */
export interface PageEventRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<EventRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageEventRead interface.
 */
export function instanceOfPageEventRead(value: object): value is PageEventRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageEventReadFromJSON(json: any): PageEventRead {
  return PageEventReadFromJSONTyped(json, false);
}

export function PageEventReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageEventRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(EventReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageEventReadToJSON(json: any): PageEventRead {
  return PageEventReadToJSONTyped(json, false);
}

export function PageEventReadToJSONTyped(
  value?: PageEventRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(EventReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
